import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../components/Icons'

import { getPeriodOptions } from './utils'

const PeriodSelect = ({ disabled, selectedDate, onSelect }) => {
  const { t } = useTranslation(['visitors'])
  return (
    <label className="visitor-analytics__period-select">
      <select
        name="period"
        value={selectedDate}
        onChange={(e) => onSelect(e.target.value)}
        disabled={disabled}
      >
        {getPeriodOptions(t).map(({ value, label }) => (
          <option value={value} key={label}>
            {label}
          </option>
        ))}
      </select>
      <Icon icon="arrow" />
    </label>
  )
}

PeriodSelect.propTypes = {
  disabled: PropTypes.bool,
  selectedDate: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default PeriodSelect
